import { render, staticRenderFns } from "./NumerciSlider.vue?vue&type=template&id=11b067fe&scoped=true&"
import script from "./NumerciSlider.vue?vue&type=script&lang=js&"
export * from "./NumerciSlider.vue?vue&type=script&lang=js&"
import style0 from "./NumerciSlider.vue?vue&type=style&index=0&id=11b067fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b067fe",
  null
  
)

export default component.exports